<template>
    <div id="settingsArea">
        <SettingsNav :items="settingsItems" :currentItem="currentItem"
            :onItemClicked="(item) => onNavItemClicked(item)" />
        <div id="settingsView">
            <div class="pageHeader" style="margin-top: 16px;">
                <ContentHeader name="Organization Settings - Miami Luxury Estates" />
                <button @click="(event) => handleButtonPress(event)">New Transaction</button>
            </div>
            <div style="background-color: white; flex: 1; flex-direction: column;">
                <OrganizationOverview :organizationData="organizationData" />
            </div>
        </div>
    </div>

</template>

<script>
import ContentHeader from '../../ContentHeader.vue';
import OrganizationOverview from './OrganizationOverview.vue';
import SettingsNav from './SettingsNav.vue';


export default {
    components: {
        SettingsNav,
        ContentHeader,
        OrganizationOverview
    },
    props: ['userData', 'organizationData'],
    data() {
        return {
            settingsItems: [
                {
                    "title": "Your Preferences",
                    "items": [
                        {
                            title: "General Info",
                            icon: require('../../../assets/Icons/b_contacts_lg.png')
                        },
                        {
                            title: "Features",
                            icon: require('../../../assets/Icons/CTicons-05.png')
                        },
                        {
                            title: "Billing",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        }
                    ]
                },
                {
                    "title": "Directory",
                    "items": [
                        {
                            title: "Communities",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Sub Divisions",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Units",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Facilities",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Users",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Roles",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                    ]
                },
                {
                    "title": "Data Management",
                    "items": [
                        {
                            title: "CX Management",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Visitor Setup",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Maintenance",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Incidents",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Violations",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                        {
                            title: "Rewards",
                            icon: require('../../../assets/Icons/CTicons-05.png')

                        },
                    ]
                },
            ],
            currentItem: "General Info"
        };
    },
    created() {

    },
    methods: {
        onNavItemClicked(item) {
            //alert(item)
            this.currentItem = item
        }
    },
};
</script>

<style scoped>
#settingsArea {
    display: flex;
    height: calc(100% - 75px);
    flex-direction: row;
}

#settingsView {
    flex: 1;
    display: flex;
    flex-direction: column;
}
</style>
